import type { FC, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem, Column, Grid } from '@carbon/react';

import { ROTULOS } from './rotulos';
import styles from './PaginaDeConta.module.scss';

// A PÁGINA DA CONTA (configurações, notificações, suporte, planos, pagamentos) — o cabeçalho de
// página do Carbon: a trilha de volta (`Breadcrumb`), o título e a descrição, as ações à direita;
// o conteúdo no grid, numa coluna de leitura. Módulo de perfil NÃO usa isto: lá o topo é a barra de
// abas.

export const PaginaDeConta: FC<{
  titulo: string;
  descricao?: string;
  /** Ações da página inteira (à direita do título; embaixo dele no celular). */
  acoes?: ReactNode;
  /** A trilha: por padrão, volta para "Seus perfis". */
  trilha?: { rotulo: string; caminho: string }[];
  /** `larga` usa as 16 colunas (tabelas); o padrão é a coluna de leitura. */
  larga?: boolean;
  /**
   * Sem o cabeçalho à vista: o título fica só para o leitor de tela. Para a página que é só um
   * estado vazio (a conta nova em Seus perfis), em que o vazio já diz tudo.
   */
  semCabecalho?: boolean;
  children: ReactNode;
}> = ({ titulo, descricao, acoes, trilha = [{ rotulo: 'Seus perfis', caminho: '/artists' }], larga, semCabecalho, children }) => {
  const navigate = useNavigate();
  const coluna = larga ? { sm: 4, md: 8, lg: 16 } : { sm: 4, md: 8, lg: 11, xlg: 10 };

  return (
    <Grid className={styles.pagina}>
      {semCabecalho ? <h1 className='cds--visually-hidden'>{titulo}</h1> : (
      <Column sm={4} md={8} lg={16}>
        {trilha.length > 0 && (
        <Breadcrumb noTrailingSlash className={styles.trilha} aria-label={ROTULOS.caminho}>
          {trilha.map((t) => (
            <BreadcrumbItem
              key={t.caminho}
              href={t.caminho}
              onClick={(e: React.MouseEvent) => { e.preventDefault(); navigate(t.caminho); }}
            >
              {t.rotulo}
            </BreadcrumbItem>
          ))}
        </Breadcrumb>
        )}
        <div className={styles.cabecalho}>
          <div className={styles.titulos}>
            <h1 className={styles.titulo}>{titulo}</h1>
            {descricao && <p className={styles.descricao}>{descricao}</p>}
          </div>
          {acoes && <div className={styles.acoes}>{acoes}</div>}
        </div>
      </Column>
      )}
      <Column {...coluna}>{children}</Column>
    </Grid>
  );
};
